import { FG_TOKEN_kEY_NAME, REFERRAL_EXPIRED_KEY, REFERRAL_KEY_NAME, AWC_KEY_NAME, AWC_EXPIRED_KEY, IS_BROWSER } from '@lib/constants';
import { getFeatureFlagState } from '@lib/data';

/**
 * Get current URL host for local storage key namespacing
 * Uses window.location.host in browser, falls back to localhost for SSR
 */
export const getCurrentUrl = () => {
  if (!IS_BROWSER) return 'localhost8000'; // SSR fallback
  return window.location.host.replace(/[^\w\s]/gi, '');
};

export const setReferral = async (referrer: string | null | undefined) => {
  if (!referrer) return;

  const currentRef = getReferral(true);
  if (!currentRef || currentRef !== referrer) {
    localStorage.setItem(`${getCurrentUrl()}_${REFERRAL_KEY_NAME}`, referrer);
  }

  // Set the referral expiry time if referrer has value
  await setReferralExpired();
};

export const setReferralExpired = async () => {
  const res = await getFeatureFlagState('affiliate-expiry-minutes', 20000, true);
  const expiryMinutes = res?.value || '60'; // Default to 60 minutes if not set
  const expiryDate = new Date().getTime() + parseInt(expiryMinutes) * 60 * 1000; // Convert hours to milliseconds
  localStorage.setItem(`${getCurrentUrl()}_${REFERRAL_EXPIRED_KEY}`, btoa(expiryDate.toString()));
};

export const setAwcExpired = async () => {
  const res = await getFeatureFlagState('affiliate-expiry-minutes', 20000, true);
  const expiryMinutes = res?.value || '60'; // Default to 60 minutes if not set
  const expiryDate = new Date().getTime() + parseInt(expiryMinutes) * 60 * 1000; // Convert hours to milliseconds
  localStorage.setItem(`${getCurrentUrl()}_${AWC_EXPIRED_KEY}`, btoa(expiryDate.toString()));
};

export const checkReferralIsValid = () => {
  const referralExpired = localStorage.getItem(`${getCurrentUrl()}_${REFERRAL_EXPIRED_KEY}`);
  if (!referralExpired || new Date() > new Date(parseInt(atob(referralExpired)))){
    deleteAffiliateData();
    return false;
  }
  return true;
};

export const setFGToken = (token: string | null | undefined) => {
  if (!token) return;
  const currentToken = getFGToken(true);
  if (!currentToken || currentToken !== token) {
    localStorage.setItem(`${getCurrentUrl()}_${FG_TOKEN_kEY_NAME}`, token);
  }
};

export const getReferral = (isSet: boolean = false) => {
  if(!isSet && !checkReferralIsValid()) return '';
  return (localStorage.getItem(`${getCurrentUrl()}_${REFERRAL_KEY_NAME}`) ?? '').toLowerCase();
};

export const getFGToken = (isSet: boolean = false) => {
  if(!isSet && !checkReferralIsValid()) return '';
  return (localStorage.getItem(`${getCurrentUrl()}_${FG_TOKEN_kEY_NAME}`) ?? '').toLowerCase();
};

export const setAwc = async (awc: string | null | undefined) => {
  if (!awc) return;

  const currentAwc = getAwc(true);
  if (!currentAwc || currentAwc !== awc) {
    localStorage.setItem(`${getCurrentUrl()}_${AWC_KEY_NAME}`, awc);
  }

  // Set the awc expiry time if awc has value
  await setAwcExpired();
};

export const getAwc = (isSet: boolean = false) => {
  if(!isSet && !checkAwcIsValid()) return '';
  return (localStorage.getItem(`${getCurrentUrl()}_${AWC_KEY_NAME}`) ?? '').toLowerCase();
};

export const checkAwcIsValid = () => {
  const awcExpired = localStorage.getItem(`${getCurrentUrl()}_${AWC_EXPIRED_KEY}`);
  if (!awcExpired || new Date() > new Date(parseInt(atob(awcExpired)))){
    deleteAwcData();
    return false;
  }
  return true;
};

export const deleteAffiliateData = () => {
  localStorage.removeItem(`${getCurrentUrl()}_${REFERRAL_KEY_NAME}`);
  localStorage.removeItem(`${getCurrentUrl()}_${FG_TOKEN_kEY_NAME}`);
  localStorage.removeItem(`${getCurrentUrl()}_${REFERRAL_EXPIRED_KEY}`);
};

export const deleteAwcData = () => {
  localStorage.removeItem(`${getCurrentUrl()}_${AWC_EXPIRED_KEY}`);
  localStorage.removeItem(`${getCurrentUrl()}_${AWC_EXPIRED_KEY}`);
};

